<ion-header [style]="'background: ' + (color || 'var(--ion-color-primary)')">
  <!-- Handle bar for sheet modal -->
  <div class="sheet-handle"></div>

  <ion-toolbar
    [style]="'--background: ' + (color || 'var(--ion-color-primary)')"
  >
    <ion-title [style]="'color: ' + contrastColor">{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="dismiss()"
        fill="clear"
        [style]="'color: ' + contrastColor"
      >
        <ion-icon
          name="close"
          slot="icon-only"
          [style]="'color: ' + contrastColor"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="webview-content">
  <div class="iframe-container" *ngIf="url">
    <iframe
      #webviewIframe
      [src]="url | safeUrl"
      width="100%"
      height="100%"
      frameborder="0"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
      (loadstart)="onIframeLoadStart()"
      (DOMContentLoaded)="onIframeDOMContentLoaded()"
      class="webview-iframe"
    >
    </iframe>

    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
      <ion-spinner name="crescent" color="primary"></ion-spinner>
      <p>Loading...</p>
      <!-- Debug info -->
      <!-- <p style="font-size: 12px; margin-top: 10px; color: white;">Debug: isLoading = {{ isLoading }}</p> -->
    </div>
  </div>

  <!-- Error state -->
  <div class="error-state" *ngIf="!url">
    <ion-icon name="alert-circle" color="danger" size="large"></ion-icon>
    <h3>No URL provided</h3>
    <p>Unable to load the content.</p>
    <ion-button fill="outline" (click)="dismiss()"> Close </ion-button>
  </div>

  <!-- Completion button - only show for PVT assessments in development -->
  <!-- <div class="completion-button-container" *ngIf="url && isPvtUrl(url) && shouldShowCompletionButton()">
    <ion-button 
      expand="block" 
      fill="solid" 
      color="success" 
      (click)="dismissWithCompletion()"
      class="completion-button">
      <ion-icon name="checkmark-circle" slot="start"></ion-icon>
      Mark as Completed
    </ion-button>
  </div> -->

  <!-- Completion status display -->
  <!-- <div class="completion-status-container" *ngIf="completionStatus">
    <div class="completion-status" [ngClass]="getStatusColorClass()">
      <ion-icon 
        [name]="isCompleted ? 'checkmark-circle' : 'information-circle'" 
        slot="start">
      </ion-icon>
      <span class="status-text">{{ getStatusDisplayText() }}</span>
    </div>
  </div> -->
</ion-content>
